<template>
  <div>
    <Navbar />
    <h4></h4>
    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPrestador" class="form-label"
                    >IdPrestador</label
                  >
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    id="idPrestador"
                    name="idPrestador"
                    v-model="datoPrestador.idPrestador"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label"
                    >RazonSocial</label
                  >
                </div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    id="razonSocial"
                    name="razonSocial"
                    v-model="datoPrestador.razonSocial"
                    style="text-transform: uppercase"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreComercial" class="form-label"
                    >NombreComercial</label
                  >
                </div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    id="nombreComercial"
                    name="nombreComercial"
                    v-model="datoPrestador.nombreComercial"
                    style="text-transform: uppercase"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ruc" class="form-label">Ruc</label>
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    id="ruc"
                    name="ruc"
                    v-model="datoPrestador.ruc"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                  <input
                    type="date"
                    class="form-control"
                    id="fechaReg"
                    name="fechaReg"
                    v-model="datoPrestador.fechaReg"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                  <input
                    type="date"
                    class="form-control"
                    id="fechaAct"
                    name="fechaAct"
                    v-model="datoPrestador.fechaAct"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-light"
            @click.prevent="guardarPrestador"
            v-if="btnCrear"
            title="Guardar"
          >
            <i
              class="material-icons"
              style="font-size: 32px; color: blue; cursor: pointer"
              >save</i
            >
          </button>
          <button
            type="submit"
            class="btn btn-light"
            @click.prevent="guardarEditPrestador"
            v-if="btnEditar"
            title="Actualizar"
          >
            <i
              class="material-icons"
              style="font-size: 32px; color: blue; cursor: pointer"
              >update</i
            >
          </button>
        </div>
      </div>
    </div>

    <!-- Details -->
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdEspePres</th>
          <th scope="col">IdPrestador</th>
          <th scope="col">IdEspecialidad</th>
          <th scope="col">IdEspecialidad2</th>
          <th scope="col">Nombre</th>
          <th scope="col">Estado</th>
          <th scope="col">PrestadorFechaReg</th>
          <th scope="col">EspecialidadNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="espepres in datosPaginados" :key="espepres.idEspePres">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(espepres.idEspePres)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(espepres.idEspePres)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ espepres.idEspePres }}</td>
          <td>{{ espepres.idPrestador }}</td>
          <td>{{ espepres.idEspecialidad }}</td>
          <td>{{ espepres.idEspecialidad2 }}</td>
          <td>{{ espepres.nombre }}</td>
          <td>{{ espepres.estado }}</td>
          <td>
            {{ getFormattedDate(espepres.prestadorFechaReg, "DD/MM/YYYY") }}
          </td>
          <td>{{ espepres.especialidadNombre }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletePrestador(espepres.idEspePres)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspePres" class="form-label"
                      >IdEspePres</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idEspePres"
                      name="idEspePres"
                      v-model="datoEspePres.idEspePres"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPrestador" class="form-label"
                      >IdPrestador</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idPrestador"
                      name="idPrestador"
                      v-model="datoEspePres.idPrestador"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label">
                      Especialidad</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idEspecialidad"
                      name="idEspecialidad"
                      v-model="datoEspePres.idEspecialidad"
                    >
                      <option
                        v-for="especialidad in especialidads"
                        :value="especialidad.idEspecialidad"
                        :key="especialidad.idEspecialidad"
                      >
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Botón Lista de Valores -->
              </div>
              <div class="mb-3">
                <!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad2" class="form-label">
                      Especialidad2</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idEspecialidad2"
                      name="idEspecialidad2"
                      v-model="datoEspePres.idEspecialidad2"
                    >
                      <option
                        v-for="especialidad2 in especialidad2s"
                        :value="especialidad2.idEspecialidad2"
                        :key="especialidad2.idEspecialidad2"
                      >
                        {{ especialidad2.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Botón Lista de Valores -->
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoEspePres.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEspePres"
              v-if="btnCrear_det"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditEspePres"
              v-if="btnEditar_det"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      // Variables master
      prestadors: [],
      datoPrestador: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      p_idPrestador: "",
      // Variables master
      // Variables details
      espepress: [],
      datoEspePres: {},
      nombreBusqueda_det: "",
      titulo_det: "",
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      especialidads: [],
      modalWindow: true,
      // Variables details
    };
  },
  mounted() {
    this.p_idPrestador = this.$route.params.p_idprestador;
    this.abrirEditar(this.p_idPrestador);
    this.getDataPagina(this.paginaActual);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = ["razonSocial", "nombreComercial", "ruc"];
      const requiredFieldsText = ["razonSocial", "nombreComercial", "ruc"];
      return validarForm(
        this.datoPrestador,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarPrestador() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/prestadors",
            this.datoPrestador
          );
          swal("Correcto!", "Prestador creada exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPrestador() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/prestadors",
            this.datoPrestador
          );
          swal("Correcto!", "Prestador creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirCrear() {
      this.modalWindow = true;
      this.datoPrestador = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirEditar(idPrestador) {
      this.modalWindow = true;
      if (idPrestador != null) {
        api.get("/vwprestadors/" + idPrestador)
          .then((resp) => {
            this.datoPrestador = resp.data;
          });
      }
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    cerrarPrestador() {
      this.$router.push("/Prestador");
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.espepress.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwespepress/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.espepress = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.espepress.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwespepress").then((response) => {
        this.espepress = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.espepress.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormDet() {
      const requiredFields = ["razonSocial", "nombreComercial", "ruc"];
      const requiredFieldsText = ["razonSocial", "nombreComercial", "ruc"];
      return validarForm(
        this.datoPrestador,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarEspePres() {
      if (this.validarForm() === 1) {
        try {
          this.datoEspePres.idPrestador = this.datoPrestador.idPrestador;
          await api.post("/espepress",
            this.datoEspePres
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "EspePres creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEspePres() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/espepress",
            this.datoEspePres
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "EspePres creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoEspePres = {};
      this.titulo = "Crear ";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
    },
    abrirModalEditar(idEspePres) {
      this.modalWindow = true;
      if (idEspePres != null) {
        api.get("/vwespepress/" + idEspePres)
          .then((resp) => {
            this.datoEspePres = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    abrirEditarDet(idEspePres) {
      this.modalWindow = true;
      if (idEspePres != null) {
        this.$router.push("/espepresmd/" + idEspePres);
      }
    },
    async deleteEspePres(idEspePres) {
      try {
        await api.delete("/espepress/" + idEspePres
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    // Procedimientos detalle
    fetchPrestadors() {
      fetch(config.apiBaseUrl + "/prestadors")
        .then((response) => response.json())
        .then((data) => {
          this.prestadors = data;
        })
        .catch((error) => {
          console.error("Error fetching prestadors:", error);
        });
    },
    fetchEspecialidads() {
      fetch(config.apiBaseUrl + "/especialidads")
        .then((response) => response.json())
        .then((data) => {
          this.especialidads = data;
        })
        .catch((error) => {
          console.error("Error fetching especialidads:", error);
        });
    },
  },
};
</script>
